export const REQUEST_INSURANCES = 'REQUEST_INSURANCES';
export const REQUEST_INSURANCES_SUCCESS = 'REQUEST_INSURANCES_SUCCESS';
export const REQUEST_INSURANCES_FAILED = 'REQUEST_INSURANCES_FAILED';
export const CONFIRM_INSURANCES = 'CONFIRM_INSURANCES';
export const CONFIRM_INSURANCES_SUCCESS = 'CONFIRM_INSURANCES_SUCCESS';
export const CONFIRM_INSURANCES_FAILED = 'CONFIRM_INSURANCES_FAILED';